import { render, staticRenderFns } from "./workplace-list.vue?vue&type=template&id=45ef9a55&"
import script from "./workplace-list.vue?vue&type=script&lang=js&"
export * from "./workplace-list.vue?vue&type=script&lang=js&"
import style0 from "./workplace-list.vue?vue&type=style&index=0&id=45ef9a55&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports